import React from "react";
import "./Header.scss";
/**
 * Renders the Cox Automotive top-level header.
 */
const Header = () => <div className="header" />;
export default Header;
